<template>
    <v-dialog class="dialog" v-model="dialogOptions" persistent max-width="400">
        <v-card> 
            <v-app-bar color="primary" dense dark>

                <v-toolbar-title>{{$t('area')}}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon text @click="$emit('closeDialog')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-app-bar>

            <v-card-text>

                <v-list dense>

                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon>mdi-map-marker</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{clickedPolygon.name}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-for="city in clickedPolygon.cities " :key="city._id">
                        <v-list-item-icon>
                            <v-icon>mdi-map</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title :class="`city-${city.name}`">{{city.name}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                </v-list>

            </v-card-text>

            <v-card-actions class="d-flex justify-center align-center">

                <v-btn color="error" @click="deleteArea" class="btn-delete-area mb-3 mt-n5">
                    {{$t('delete')}}
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { DELETE_AREA, GET_POLYS } from '../../../store/mutations';

export default {

    name: 'DialogAreaOptions',

    props: ['clickedPolygon', 'dialogOptions'],

    data() {
        return {
            loading: false
        }
    },

    computed: {

        ...mapGetters({

            page: 'AreaVuex/mapPage',
            getProvider: `ProviderVuex/provider`,

        }),

    },

    methods: {

        ...mapActions({

            getAreas: `AreaVuex/${GET_POLYS}`,
            deleteSelectedArea: `AreaVuex/${DELETE_AREA}`,

        }),

        async deleteArea() {

            this.loading = true;

            let loader = this.$loading.show({ 'is-full-page': true, color: 'green' });

            try {

                await this.deleteSelectedArea(this.clickedPolygon._id)

                await this.$emit('cleanPolyData')

                return this.showToast(this.$t('provider_dashboard.toast_area_delete_msg'), this.$t('provider_dashboard.toast_area_delete_title'), 'success')

            } catch (error) {

                console.log(error)

                return this.showToast(this.$t('provider_dashboard.toast_area_error_delete_msg'), this.$t('provider_dashboard.toast_area_error_delete_title'), 'error')

            } finally {

                this.$emit('cleanPoly')
                this.$emit('closeDialog')
                
                loader.hide();

            }



        },
    }

}
</script>

<style>

</style>